import { render } from "./partner-header.vue?vue&type=template&id=35d4cb5e"
import script from "./partner-header.vue?vue&type=script&lang=js"
export * from "./partner-header.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__